import { gql } from '@apollo/client';

export const UPSERT_PROGRAMME_REPORTER = gql`
  mutation UpsertProgrammeReporter($input: UpsertProgrammeReporterInput!) {
    programmeReporter: upsertProgrammeReporter(input: $input) {
      id
    }
  }
`;
